<template>
  <div class="h-100 d-flex flex-column">
    <div class="w-100" style="height: 90px">
      <div
        class="px-2 py-1 h-100 d-flex justify-content-between align-items-center"
        style="gap: 20px"
      >
        <template v-if="getAtmScreen === atmScreenEnum.CATALOG">
          <e-button
            variant="danger"
            class="atm-btn"
            :text="$t('Cancelar compra')"
            @click="() => onCancel({})"
          />

          <e-button
            variant="primary"
            class="atm-btn"
            :text="$t('Carrinho')"
            @click="() => onShowCart()"
          >
            <template #right-content>
              <b-badge v-if="getCartItemsQuantity > 0" variant="danger">
                {{ getCartItemsQuantity }}
              </b-badge>
            </template>
          </e-button>
        </template>

        <template v-if="getAtmScreen === atmScreenEnum.PAYMENT">
          <e-button
            v-if="showReturn"
            :busy="isBusy"
            variant="secondary"
            class="atm-btn"
            :text="$t('Voltar')"
            @click="() => onBack()"
          />

          <e-button
            v-if="showCancel"
            variant="danger"
            class="w-100 h-100 atm-btn"
            :text="$t('Cancelar compra')"
            size="lg"
            @click="() => onCancel({})"
          />

          <e-button
            v-if="showFinish"
            :busy="isBusy"
            variant="primary"
            class="atm-btn"
            :text="$t('Finalizar')"
            @click="() => onFinish()"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import { atmScreenEnum } from '@/store/pages/pdv/atm/atm-status'
import EButton from '@/views/components/EButton.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { invoiceDomains, loadingOverlay } from '@/mixins'
import delegablePermissions from '@/utils/delegable-permissions'

export default {
  components: {
    EButton,
    BBadge,
  },

  mixins: [loadingOverlay],

  props: {
    isBusy: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    atmScreenEnum,
  }),

  computed: {
    ...mapState('app', ['modalAuthRef']),
    ...mapState('pages/pdv/payBox', ['items', 'paymentForm', 'invoiceReturn']),

    ...mapGetters('pages/pdv/atm/status', [
      'getAtmScreen',
      'getIsFinishError',
      'getIsPaymentError',
    ]),
    ...mapGetters('pages/pdv/payBox', [
      'getItems',
      'hasPayments',
      'hasActiveTefCardPayment',
      'hasActiveTefPixPayment',
      'getCartItemsQuantity',
    ]),

    showReturn() {
      return !this.hasPayments
    },
    showCancel() {
      return this.getIsPaymentError || this.getIsFinishError || this.hasPayments
    },
    showFinish() {
      return this.getIsFinishError || this.hasPayments
    },
  },

  methods: {
    ...mapActions('pages/pdv/payBox', {
      stValidateFinishSale: 'validateFinishSale',
      stFinishSale: 'finishSale',
      stSetClientForm: 'setClientForm',
      stAddTempDelegation: 'AddTempDelegation',
      stCancelIncompleteInvoice: 'cancelIncompleteInvoice',
    }),
    ...mapActions('pages/pdv/atm', {
      stCleanAtmState: 'cleanState',
    }),
    ...mapActions('pages/pdv/atm/status', {
      stSetAtmScreen: 'setAtmScreen',
      stSetIsCartOpen: 'setIsCartOpen',
    }),
    ...mapActions('pages/pdv/atm/catalog', {
      stSetFiltersAndSearch: 'setFiltersAndSearch',
      cleanCatalog: 'cleanCatalog',
    }),

    async onBack() {
      this.stSetAtmScreen(atmScreenEnum.CATALOG)
    },

    async onShowCart() {
      this.stSetIsCartOpen(true)
    },

    async onCancel({ forceExit }) {
      try {
        let paymentErrorMessage = ''

        if (!this.isOrder) {
          if (this.hasActiveTefCardPayment) {
            paymentErrorMessage = 'PAY_BOX_SALE.CANCEL.ATM.CONFIRMATION_TEF_PAYMENT_CARD_ACTIVE'
          } else if (this.hasActiveTefPixPayment) {
            paymentErrorMessage = 'PAY_BOX_SALE.CANCEL.ATM.CONFIRMATION_TEF_PAYMENT_PIX_ACTIVE'
          }
        }

        if (paymentErrorMessage) {
          this.showAtmAlert({
            title: this.$t('Pagamentos'),
            text: this.$t(paymentErrorMessage),
            icon: 'error',
            timer: null,
          })
          return
        }

        if (!forceExit) {
          let actionMsg = this.$t('Deseja realmente cancelar esta compra?')

          if (this.isBarConsumption)
            actionMsg = this.$t(
              'Deseja sair do fechamento da comanda? As alterações feitas serão perdidas.'
            )

          const confirm = await this.confirm({
            text: actionMsg,
            focusCancel: true,
          })
          if (!confirm) return

          // TODO ATM cancelamento normal?
          // switch (true) {
          //   case this.isOrder && !this.orderChanged:
          //     break
          //   default:
          //     this.delegateUserData = await this.modalAuthRef.auth(delegablePermissions.PDV_CANCEL)
          // }
        }

        if (this.invoiceReturn && this.invoiceReturn?.model === 'NFE') {
          let delegablePermission = delegablePermissions.ERP_INVOICE_MANAGE

          if (this.invoiceReturn.status === invoiceDomains.data().statusInvoiceEnum.REJECTED) {
            delegablePermission = delegablePermissions.ERP_INVOICE_INVALIDATE
          }

          const delegateUserData = await this.modalAuthRef.auth(delegablePermission)
          await this.stAddTempDelegation(delegateUserData)
        }

        this.showLoadingOverlay(this.$t('Aguarde um momento, estamos cancelando sua compra.'))

        await this.stCancelIncompleteInvoice()

        await this.onCleanSale()

        await this.showAtmAlert({ title: this.$t('Compra cancelada'), icon: 'success' })

        // Redireciona para a tela de identificação do cliente após cancelar a compra
        this.$router.push({ name: 'pdv-atm-identify-customer' })
      } catch (error) {
        console.error(error)
        if (error.message) {
          this.showAtmAlert({ title: 'Aviso', text: error.message, icon: 'warning' })
        } else {
          this.showAtmAlert({ error, icon: 'error' })
        }
      } finally {
        this.hideLoadingOverlay()
      }
    },

    async onFinish() {
      this.$emit('finish-sale')
    },

    async onCleanSale() {
      await this.stCleanAtmState()
      this.cleanCatalog()
    },
  },
}
</script>
